import { render } from "./moment.vue?vue&type=template&id=2ced7a48&scoped=true&ts=true"
import script from "./moment.vue?vue&type=script&lang=ts"
export * from "./moment.vue?vue&type=script&lang=ts"

import "./moment.vue?vue&type=style&index=0&id=2ced7a48&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ced7a48"]])

export default __exports__